import FadeIn from '@/components/FadeIn/FadeIn';
import AutoScroll from 'embla-carousel-auto-scroll';
import useEmblaCarousel from 'embla-carousel-react';
import Image from 'next/image';
import * as React from 'react';

type IClientsProps = object;

const IMAGES = [
  '/images/brand/brand-light-01.svg',
  '/images/brand/brand-light-03.svg',
  '/images/brand/brand-light-11.svg',
  '/images/brand/brand-light-09.svg',
  '/images/brand/HCITL_grayscale.png',
  '/images/brand/datablaze_grayscale.png',
  '/images/brand/helix_grayscale.png',
  '/images/brand/hologram_gray.png',
  '/images/brand/soracom_grayscale.png',
  '/images/brand/parks_associates_grayscale.png',
];

const Clients: React.FunctionComponent<IClientsProps> = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    AutoScroll({ playOnInit: true, stopOnInteraction: false, stopOnFocusIn: false, speed: 0.7 }),
  ]);

  return (
    <section className='section-clients bg-white pt-10 pb-8 tablet:pt-11.5 tablet:pb-13'>
      <div className='container-fluid px-4 md:px-10'>
        <FadeIn variant='down' delay={0.3}>
          <p className='text-xl sm:text-[1.25rem] text-black-200 text-center pb-6 sm:pb-[38px]'>
            Trusted by Founders and Enterprises
          </p>
        </FadeIn>

        <FadeIn variant='up' delay={0.3}>
          <div className='infinity-carousel flex items-center'>
            <div className='group animate-[scrolling_150s_linear_infinite] flex gap-15 md:gap-30 pr-15 md:pr-30'>
              {[...IMAGES, ...IMAGES, ...IMAGES, ...IMAGES, ...IMAGES, ...IMAGES, ...IMAGES].map(
                (item, index) => (
                  <Image
                    key={index}
                    src={item}
                    alt='Clients'
                    width={112}
                    height={48}
                    className={`opacity-65 transition-all duration-300 hover:opacity-100 max-w-[80px] md:max-w-[112px] justify-between ${
                      item.includes('.png') ? 'object-contain' : ''
                    } ${
                      item.includes('parks_associates') || item.includes('soracom') 
                        ? 'max-w-[60px] md:max-w-[80px]' 
                        : ''
                    }`}
                    style={{
                      filter: item.includes('helix') ? 'brightness(1.5) contrast(0.8)' : 'none'
                    }}
                    unoptimized
                  />
                ),
              )}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default Clients;
